import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppLayoutStateService {
    isInModalMode = false;

    setModalMode(isInModalMode: boolean) {
        this.isInModalMode = isInModalMode;
    }
}
